import type * as React from "react";
export const ActivityIcon = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width={24}
			height={24}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<circle cx={12} cy={12} r={12} fill="#00C0AA" />
			<path
				d="M4.5 11.7857H7.875L9.375 7.5L11.25 16.5L13.875 12.375L15.375 14.25L17.25 11.7857H19.5"
				stroke="white"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
